import { getAttachmentUrl } from 'owa-attachment-url';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { ClientAttachmentId } from 'owa-client-ids';
import { AttachmentUrlType } from 'owa-files-url';
import { downloadAttachmentFromUrl } from './downloadAttachmentFromUrl';

export function download(itemId: ClientAttachmentId, attachmentFile: AttachmentType) {
    const downloadUrl = getAttachmentUrl(
        itemId,
        attachmentFile,
        AttachmentUrlType.FullFile,
        false,
        false,
        true
    );
    downloadAttachmentFromUrl(downloadUrl, false);
}
